<template>
  <div>
    <div ref="table" style="position:relative">
      <table>
        <tbody>
          <tr>
            <td>
              <div class="label top left red">
                オープン
              </div>
            </td>
            <td>
              <div class="label top right blue">
                フォーカス
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="label bottom left yellow">
                アセプト
              </div>
            </td>
            <td>
              <div class="label bottom right green">
                メンテナンス
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="overlap-table">
        <div class="axis" :class="item.department.id" v-for="item in stats" :key="item.id" :style="calculatePosition(item)">
          <span
            class="axis-label"
            :class="item.id.match(/^APL#.+?#$/) ? 'applicants' : item.id.match(/^.+#retired#$/) ? 'retired' : ''"
          >
            ●&nbsp;{{ item.name }}
            <div
              class="tooltip"
              :style="{
                display: focus && focus.id === item.id && focus.selected ? 'block' : 'none'
              }"
            >
              {{ item.name }}<br />
              {{ item.department.name }}
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.overlap-table {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 90%;
  height: 100%;
}
table {
  width: 90%;
  max-height: 500px;
  min-height: 300px;
  height: 100vh;
  border-collapse: collapse;
  position: relative;
}
.axis {
  position: absolute;
  color: #000;
  font-weight: 600;
  height: 20px;
}
.axis-label {
  position: absolute;
  white-space: nowrap;
  color: $employee-color !important;
  &.applicants {
    color: $applicant-color !important;
  }
  &.retired {
    color: $retired-color !important;
  }
}
td {
  border: 2px solid $chart-grid-color;
  width: 50%;
  height: 50%;
  .label {
    position: absolute;
    width: 105px;
    padding: $spacing-minimum;
    text-align: center;
    &.top {
      top: 0;
    }
    &.right {
      right: 0;
    }
    &.left {
      left: 0;
    }
    &.bottom {
      bottom: 0;
    }
    &.red {
      background-color: $chart-instruction-color-red !important;
    }
    &.yellow {
      background-color: $chart-instruction-color-yellow !important;
    }
    &.green {
      background-color: $chart-instruction-color-green !important;
    }
    &.blue {
      background-color: $chart-instruction-color-blue !important;
    }
  }
}
.tooltip {
  z-index: 1;
  position: absolute;
  top: 30px;
  left: -15px;
  background-color: #888;
  color: #fff;
  padding: 8px;
  min-width: 100px;
  display: none;
  font-size: 1rem;
  &:after {
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    pointer-events: none;
    position: absolute;
    border-color: rgba(238, 238, 238, 0);
    border-top-width: 10px;
    border-bottom-width: 10px;
    border-left-width: 10px;
    border-right-width: 10px;
    margin-left: -10px;
    border-bottom-color: #888;
    bottom: 100%;
    left: 19px;
  }
}
</style>
<script lang="ts">
import { Ref, Prop } from "vue-property-decorator";
import { SelectableProfile, UserRDStats } from "../../types";
import ChartMixin from "../../helpers/mixins/chart";
export default class RDAnalyticsChart extends ChartMixin {
  @Prop({ type: Array, required: true }) stats: UserRDStats[] = [];
  @Prop({ type: Object }) focus: Partial<SelectableProfile> = {};
  @Ref("table") table!: HTMLElement;
  draw() {
    this.$forceUpdate();
  }
  calculatePosition(stats: UserRDStats) {
    const x = stats.axis.rd_mx > 80 ? 80 : stats.axis.rd_mx < 20 ? 20 : stats.axis.rd_mx;
    const y = stats.axis.rd_my > 100 ? 100 : stats.axis.rd_my < 0 ? 0 : stats.axis.rd_my;
    const circleWidth = 14.75;
    const circleHeight = 18;
    return {
      left: `calc(${(5 * x - 100) / 3}% - ${circleWidth / 2}px)`,
      bottom: `calc(${y}% - ${circleHeight / 2}px`
    };
  }
}
</script>
